import narrationManifest from '@/_data/coreNarrationManifest';
import { createBrowserEpisodeNarrationOwner } from '@/episodeNarration';
import { createEpisodePlaybackEffectOwner } from '@/episodePlayback';
import { resolveCoreEpisode } from './episodeCatalog';
import { runtimeController } from './runtime';
import type { Config, CosmosDataModel, RuntimeState } from './_contract/config';

type Args = { config: Config; runtimeState: RuntimeState; cosmosData: CosmosDataModel;
    playbackActive?: boolean; animationSuspended?: boolean };

export function createCoreEpisodeEffectOwner(narration = createBrowserEpisodeNarrationOwner()) {
    return createEpisodePlaybackEffectOwner<RuntimeState, Args>({
        select: args => {
            const playback = args.runtimeState.episode;
            if (!playback) throw new Error('Core narration requires an active episode.');
            const { scene } = resolveCoreEpisode(playback.episodeHandle, args.runtimeState.sceneIndex ?? 0);
            const beat = scene.beats[playback.beatIndex];
            const update = args.config.runtimeCallbacks?.onRuntimeStateChange;
            if (!beat || !update) throw new Error('Core narration requires a beat and runtime update callback.');
            return { sceneId: scene.id, beat, recording: { clips: narrationManifest.clips, catalog: 'core' }, update };
        },
        continue: (args, state) => runtimeController.reduceOverlayIntent({ ...args, runtimeState: state,
            intent: { overlayIntentKind: 'action-triggered', actionId: 'episode-continue' } }),
    }, narration);
}
